import { Component } from '@angular/core';
import { convertMenuData, extractTabActions } from './utilities/fn';
import { DataMenu } from './shared/dataMenu';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'ucart';

  update() {
    console.log("Menu", JSON.stringify(convertMenuData(DataMenu)))

    console.log("action", JSON.stringify(extractTabActions(DataMenu, 'action')))

    console.log("tab", JSON.stringify(extractTabActions(DataMenu, 'tab')))

    // console.log("tab", JSON.stringify(extractTabActions(DataMenu, 'subtab')))
  }
}
